export const SEARCH_TAG = "app/FEEDACTION/SEARCH_TAG";
export const SEARCH_TAG_SUCCESS = "app/FEEDACTION/SEARCH_TAG_SUCCESS";
export const SEARCH_TAG_FAILURE = "app/FEEDACTION/SEARCH_TAG_FAILURE";

export const UPDATE_FEED_TAGS = "app/FEEDACTION/UPDATE_FEED_TAGS";
export const RESET_FEED_TAGS = "app/FEEDACTION/RESET_FEED_TAGS";

export const DELETE_TAG = "app/FEEDACTION/DELETE_TAG";
export const DELETE_TAG_SUCCESS = "app/FEEDACTION/DELETE_TAG_SUCCESS";
export const DELETE_TAG_FAILURE = "app/FEEDACTION/DELETE_TAG_FAILURE";

export const ADD_REACTION = "app/FEEDACTION/ADD_REACTION";
export const ADD_REACTION_SUCCESS = "app/FEEDACTION/ADD_REACTION_SUCCESS";
export const ADD_REACTION_FAILURE = "app/FEEDACTION/ADD_REACTION_FAILURE";

export const FETCH_REACTIONS = "app/FEEDACTION/FETCH_REACTIONS";
export const FETCH_REACTIONS_SUCCESS = "app/FEEDACTION/FETCH_REACTIONS_SUCCESS";
export const FETCH_REACTIONS_FAILURE = "app/FEEDACTION/FETCH_REACTIONS_FAILURE";

export const TOGGLE_REACTION_MODAL = "app/FEEDACTION/TOGGLE_REACTION_MODAL";
export const TOGGLE_REPORT_MODAL = "app/FEEDACTION/TOGGLE_REPORT_MODAL";

export const ACKNOWLEDGE_FEED = "app/FEEDACTION/ACKNOWLEDGE_FEED";
export const ACKNOWLEDGE_FEED_SUCCESS =
  "app/FEEDACTION/ACKNOWLEDGE_FEED_SUCCESS";
export const ACKNOWLEDGE_FEED_FAILURE =
  "app/FEEDACTION/ACKNOWLEDGE_FEED_FAILURE";

export const FETCH_STATS = "app/FEEDACTION/FETCH_STATS";
export const FETCH_STATS_SUCCESS = "app/FEEDACTION/FETCH_STATS_SUCCESS";
export const FETCH_STATS_FAILURE = "app/FEEDACTION/FETCH_STATS_FAILURE";

export const FETCH_ENGAGE_REPORT = "app/FEEDACTION/FETCH_ENGAGE_REPORT";
export const FETCH_ENGAGE_REPORT_SUCCESS =
  "app/FEEDACTION/FETCH_ENGAGE_REPORT_SUCCESS";
export const FETCH_ENGAGE_REPORT_FAILURE =
  "app/FEEDACTION/FETCH_ENGAGE_REPORT_FAILURE";

export const ENGAGE_REPORT_FILTERS = "app/FEEDACTION/ENGAGE_REPORT_FILTERS";
